import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 9.29a2.58 2.58 0 1 1 2.57-2.58A2.58 2.58 0 0 1 8 9.29Zm0-3.66a1.08 1.08 0 1 0 1.08 1.08A1.08 1.08 0 0 0 8 5.63Zm0-4.54a5.62 5.62 0 0 0-5.61 5.62.09.09 0 0 1 0 .08A6.36 6.36 0 0 0 4 11.11a31.93 31.93 0 0 0 3.41 3.71.65.65 0 0 0 .18.15h.12a.19.19 0 0 0 .1 0h.31a.2.2 0 0 0 .11 0h.1l.07-.05h.07A32.58 32.58 0 0 0 12 11.11a6.5 6.5 0 0 0 1.66-4.37A5.62 5.62 0 0 0 8 1.09Zm4.13 5.71a5 5 0 0 1-1.35 3.39A31 31 0 0 1 8 13.29a28.76 28.76 0 0 1-2.78-3.1 5 5 0 0 1-1.33-3.48 4.12 4.12 0 0 1 8.24 0 .28.28 0 0 0 0 .09Z';
const draw24px =
  'M11.92,13.49A3.68,3.68,0,1,1,15.6,9.81,3.68,3.68,0,0,1,11.92,13.49Zm0-5.86A2.18,2.18,0,1,0,14.1,9.81,2.18,2.18,0,0,0,11.92,7.63Zm0-6.38A8.57,8.57,0,0,0,3.36,9.81v.13c0,1.07,0,3.29,2.57,6.64a50.2,50.2,0,0,0,5.43,5.92.68.68,0,0,0,.41.23l.15,0,.15,0a.68.68,0,0,0,.35-.17l.06-.06a50.2,50.2,0,0,0,5.43-5.92c2.58-3.35,2.57-5.57,2.57-6.64V9.81A8.57,8.57,0,0,0,11.92,1.25ZM19,10c0,1,0,2.78-2.25,5.72A50.68,50.68,0,0,1,11.92,21a49.57,49.57,0,0,1-4.81-5.3C4.85,12.73,4.86,10.92,4.86,10V9.81A7.06,7.06,0,0,1,19,9.81Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PinIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'pin'),
) as IconWithRender;

PinIcon.displayName = 'PinIcon';
PinIcon.propTypes = Icon.propTypes;
PinIcon.renderIcon = (props) => <PinIcon {...props} />;
export default PinIcon;
